import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import type {BatchJobId as UUID} from '@netx/core-app/models/batchJob';
import {CustomActionPayloadType} from '../constants';
import type {CustomActionID} from '../types';

/**
 * `triggerCustomAction` request params
 * (what is used to send to server)
 */
export type TriggerCustomActionRequestOptions = {
	id: CustomActionID;
	data: {
		payload: CustomActionPayloadType;
	};
};

/**
 * `triggerCustomAction` request
 * (what gets sent to the server)
 */
export type TriggerCustomActionRequest = [
	TriggerCustomActionRequestOptions['id'],
	TriggerCustomActionRequestOptions['data'],
];

/**
 * `triggerCustomAction` response
 * (what comes back from the server)
 */
export type TriggerCustomActionResponse =
	SuccessResponse<TriggerCustomActionResult>;

/**
 * `triggerCustomAction` result
 * (what is utilized from the server response)
 */
export type TriggerCustomActionResult = UUID;

export const triggerCustomActionEndpoint = 'triggerCustomAction';

/**
 * Trigger custom action
 */
export const triggerCustomAction = async (
	{id, data}: TriggerCustomActionRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: TriggerCustomActionRequest = [id, data];

	return client
		.post<TriggerCustomActionResponse>(
			triggerCustomActionEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default triggerCustomAction;
